import React, {useEffect, useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button"; 
import LineSaleEntryPayment from "./lineSaleEntryPayment";
import {MaterialTable} from '../../../components';
import Icon from '@material-ui/core/Icon';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(2, 0)
    }
}));

let currentPayment = undefined
let editPaymentMode = false
const LineSaleEntryPaymentDetails = ({onPaymentEdit, data ,banks,   handlePaymentDetailsClose, showPaymentDetailsDialog, onLineSaleEntryPaymentSave,
     onLineSaleEntryPaymentDelete, loading}) => {
    const classes = useStyles();
    const [showPaymentDialog, setShowPaymentDialog] = useState(false)
    const [lineSaleEntriesPayments, setLineSaleEntryPayments] = useState([])

     const reset = () => {
        console.debug(data)
        if(showPaymentDetailsDialog && data !== undefined && data.lineSaleEntriesPayments !== undefined && data.lineSaleEntriesPayments !== null){
            console.debug(data)
            setLineSaleEntryPayments(data.lineSaleEntriesPayments);
        }else{
            setLineSaleEntryPayments([])
        }
    };
    useEffect(reset, [showPaymentDetailsDialog,data]);


    function onNewPayment(event) {
        editPaymentMode = false;
        event.preventDefault();
        setShowPaymentDialog(true);
    } 

    function onEdit(rowData) {
        rowData = {
            ...rowData,
            bankIndex:banks.findIndex((bank)=>{return bank.id === rowData.paymentBankId;})
        };
        currentPayment = rowData
        editPaymentMode = true
        setShowPaymentDialog(true);
    }

    function onPaymentDelete(rowData) {
        console.debug(rowData,lineSaleEntriesPayments)
        let index = lineSaleEntriesPayments.findIndex((srcLineSaleEntryPayment) => {
            return srcLineSaleEntryPayment.id === rowData.id;
        });
        let newLineSaleEntryPayments = lineSaleEntriesPayments;
        newLineSaleEntryPayments.splice(index, 1); 
        console.debug(newLineSaleEntryPayments)
        setLineSaleEntryPayments(newLineSaleEntryPayments)
        let tempCurrentData = {
            ...data,
            lineSaleEntriesPayments :newLineSaleEntryPayments
        }
        onLineSaleEntryPaymentDelete(rowData, tempCurrentData)
        console.debug(lineSaleEntriesPayments)
    }


    function onPaymentSave(payment) {
        console.debug(payment,data)
        console.debug(lineSaleEntriesPayments)
        if(editPaymentMode){
            let index = lineSaleEntriesPayments.findIndex((srcPayement) => {
                return srcPayement.id === payment.id;
            });
            setLineSaleEntryPayments([...lineSaleEntriesPayments.slice(0, index),
                {...payment},
                ...lineSaleEntriesPayments.slice(index + 1)])
    
            let tempCurrentData ={
                ...data,
                lineSaleEntriesPayments :[...lineSaleEntriesPayments.slice(0, index),
                    {...payment},
                    ...lineSaleEntriesPayments.slice(index + 1)]
            }

            onPaymentEdit(payment, tempCurrentData)
        }else{
            payment = {
                ...payment,
                lineSaleEntriesID : data.id
            }
            onLineSaleEntryPaymentSave(payment)
        }
        setShowPaymentDialog(false);
        console.debug(lineSaleEntriesPayments)
    }


    function handlePaymentClose() {
        currentPayment = undefined;
        setShowPaymentDialog(false);
    }

    let actions = [
        rowData => ({
            icon: () => <Icon color='primary'>edit</Icon>,
            tooltip: 'Edit lineSaleEntry Details',
            onClick: (event, rowData) => onEdit(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" ? true : false
        }),
        rowData => ({
            icon: () => <Icon color='error'>delete</Icon>,
            tooltip: 'Delete lineSaleEntry Details',
            onClick: (event, rowData) => onPaymentDelete(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" ? true : false
        })
    ]
    return <Dialog maxWidth='md' open={showPaymentDetailsDialog} onClose={handlePaymentDetailsClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog- title"   >Line Sale Entry Payments</DialogTitle>
          <DialogContent>
            <div className={classes.button} >
                <Button variant="contained" color="primary" onClick={onNewPayment}>Add Payment</Button>
            </div>

            <MaterialTable
            isLoading={loading}
            columns={[
                {title: 'id', field: 'id', hidden: true},
                {title: 'Payment Date', field: 'paymentDate',  editable: 'never',
                render: rowData => {
                    return <span>{moment(rowData.paymentDate).format("DD-MM-YYYY")}</span>
                }
                },
                {title: 'Payment Amount', field: 'paymentAmount',  editable: 'never'},
                {title: 'Payment Mode', field: 'paymentMode', editable: 'never',
                render: rowData => {
                    return <span>{rowData.paymentMode === 0 ? '' : (rowData.paymentMode === 1 ? 'Cash' : rowData.paymentBankName.String)}</span>
                }
                },
                {title: 'paymentBankId', field: 'paymentBankId', editable: 'never', hidden: true},
                {title: 'Payment Note', field: 'paymentNote', editable: 'never'},
            ]}
            data={lineSaleEntriesPayments}
            options={{
                actionsColumnIndex: -1,
                search: false,
                showTitle: false,
                
                toolbar: false,
                paging:false
            }} 
            //style={{boxShadow: 'unset'}}
            actions={actions}
            /> 

 {showPaymentDialog ? 

                 <LineSaleEntryPayment banks={banks} data={currentPayment} onSave={onPaymentSave} handlePaymentClose={handlePaymentClose} 
                showPaymentDialog={showPaymentDialog} editMode={editPaymentMode} >
                </LineSaleEntryPayment>  

                : null
            }
            <DialogActions>
                <Button
                    className={classes.button}
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={handlePaymentDetailsClose}
                >
                    Close
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>
};

export default LineSaleEntryPaymentDetails;